import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { EstratoSocial } from '../../models/estrato-social/estrato-social';

@Injectable({
  providedIn: 'root',
})
export class EstratosSocialesService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.ESTRATOS_SOCIALES}`;
  constructor(private http: HttpClient) {}

  getEstratosSociales(): Observable<EstratoSocial[]> {
    return this.http.get<EstratoSocial[]>(this.apiUrl);
  }
}
